import { toIsoDate } from '../../Protocols.utils';

import type { ProtocolRequest, ProtocolResponse } from 'generated/index';
import type {
  ProtocolDateValue,
  ProtocolFormValues
} from './ProtocolForm.types';

/** The picker's value as a plain calendar date, see `toIsoDate` for why it is never a `Date` */
export const toProtocolDate = (
  value: ProtocolDateValue
): string | undefined => {
  if (!value) {
    return undefined;
  }
  return typeof value === 'string' ? value : toIsoDate(value.toDate());
};

/** A new protocol starts today and is valid indefinitely */
export const toProtocolFormValues = (
  protocol?: ProtocolResponse,
  today: Date = new Date()
): ProtocolFormValues => ({
  name: protocol?.name ?? '',
  validFrom: protocol?.validFrom ?? toIsoDate(today),
  validUntil: protocol?.validUntil ?? null
});

export const toProtocolRequest = ({
  name,
  validFrom,
  validUntil
}: ProtocolFormValues): ProtocolRequest => ({
  name: name.trim(),
  validFrom: toProtocolDate(validFrom) ?? '',
  validUntil: toProtocolDate(validUntil)
});
